import {getServiceFunction} from "@project/sdk/engineering";
import {GetServiceFunctionResponse} from "@project/sdk/engineering/zod";
import {queryOptions} from "@tanstack/react-query";

import {queryPolicyDefaults} from "../../../../../shared/query/query-policies";
import {serviceFunctionKeys} from "../../../serviceFunction-keys";

export function getServiceFunctionQueryOptions(serviceFunctionId: string, includeDeleted = false) {
  return queryOptions({
    ...queryPolicyDefaults.warm,
    staleTime: 0,
    queryKey: [...serviceFunctionKeys.detail(serviceFunctionId), {includeDeleted}] as const,
    queryFn: async ({signal}) =>
      GetServiceFunctionResponse.parse(
        await getServiceFunction(serviceFunctionId, {includeDeleted}, {signal}),
      ),
  });
}
